export const HEARD_OPTIONS = [
  "Search engine (Google, Bing…)",
  "Friend or colleague",
  "Social media",
  "Reddit",
  "YouTube",
  "Switching from TeamViewer / AnyDesk",
  "A blog or article",
  "Other",
];
